import MainLayout from 'layouts/MainLayout';

import Start from '../pages/Start';
import Conversation from '../pages/Conversation';

const routes =  [{
    layout: MainLayout,
    routes: [{
        path: '/agents/:agentId/lawyer-dataset-creator',
        element: Start,
        exact: true,
        analytics: { name: ["Agente", "Lawyer Dataset Creator"] },
    }, {
        path: '/agents/:agentId/lawyer-dataset-creator/conversations/:conversationId',
        element: Conversation,
        exact: true,
        analytics: { name: ["Agente", "Conversazione"] },
    }]
}]

export default routes;